import EditorView from './editor-view'

const Img = {
  props: {
    params: {
      default: () => ({})
    }
  },
  render() {
    return <img draggable="false" class="match-parent" src={this.params.url} />
  }
}

const Signature = {
  props: {
    params: {
      default: () => ({})
    },
    meta: {
      default: () => ({ children: [] })
    }
  },
  methods: {
    // <div style="border:1px solid red;background:#c1f1b8;text-align:center" draggable="false" class="match-parent" >
    // </div>
  },
  render() {
    return (
      <div draggable="false" class="match-parent" id={this.meta.id}>
        <span
          class="match-parent"
          draggable="false"
          style={
            'cursor:pointer;border:2px solid ' +
            this.params.borderColor +
            ';background:' +
            this.params.color +
            ';color:black;display: flex;align-items: center;justify-content: center;font-size:12px;padding:4px;box-sizing:border-box;min-height:32px;'
          }>
          {' '}
          簽 名 框{' '}
        </span>
      </div>
    )
  }
}

const Label = {
  props: {
    params: {
      default: () => ({})
    }
  },
  render() {
    return (
      <div draggable="false" class="match-parent">
        {this.params.value}
      </div>
    )
  }
}

const Container = {
  props: {
    params: {
      default: () => ({})
    },
    meta: {
      default: () => ({ children: [] })
    }
  },
  // #d4d4d4
  render() {
    return (
      <div
        style={'border:1px solid' + this.params.color + ';background:' + this.params.color + '00'}
        draggable="false"
        class="match-parent">
        <EditorView parentId={this.meta.id} value={this.meta.children} />
      </div>
    )
  }
}

const Input = {
  props: {
    params: {
      default: () => ({
        value: '',
        type: 'input'
      })
    },
    meta: {
      default: () => ({ children: [] })
    }
  },
  methods: {},
  // v-model={this.params.value}
  // checked={this.params.value === true}
  // disabled = true -  template
  render() {
    if (['checkbox'].includes(this.params.inputType)) {
      const pointerEventsStyle = this.params.disabled === true ? 'pointer-events:none;' : ''
      return (
        <label
          class="match-parent input-has-label"
          style={
            'border:2px solid ' +
            this.params.borderColor +
            ';background:' +
            this.params.color +
            ';' +
            pointerEventsStyle
          }>
          {this.params.usertype === 'Doctor' && this.params.disabled === false ? (
            <input type="checkbox" class="match-parent" id={this.meta.id} v-model={this.params.value}>
              {this.params.label}
            </input>
          ) : this.params.disabled ? (
            <input type="checkbox" class="match-parent" id={this.meta.id} checked={false} style={pointerEventsStyle}>
              {this.params.label}
            </input>
          ) : (
            <input disabled type="checkbox" class="match-parent" id={this.meta.id} v-model={this.params.value}>
              {this.params.label}
            </input>
          )}
        </label>
      )
    }
    if (['radio'].includes(this.params.inputType)) {
      const pointerEventsStyle = this.params.disabled === true ? 'pointer-events:none;' : ''
      return (
        <label
          class="match-parent input-has-label"
          style={
            'border:2px solid ' +
            this.params.borderColor +
            ';background:' +
            this.params.color +
            ';' +
            pointerEventsStyle
          }>
          {this.params.usertype === 'Doctor' && this.params.disabled === false ? (
            <input
              type="radio"
              class="match-parent"
              id={this.meta.id}
              name={this.meta.parentId ? this.meta.parentId : 'radioComponents'}
              checked={this.params.value === true}>
              {this.params.label}
            </input>
          ) : this.params.disabled ? (
            <input
              type="radio"
              class="match-parent"
              id={this.meta.id}
              name={this.meta.parentId ? this.meta.parentId : 'radioComponents'}
              checked={false}
              style={pointerEventsStyle}>
              {this.params.label}
            </input>
          ) : (
            <input
              disabled
              type="radio"
              class="match-parent"
              id={this.meta.id}
              name={this.meta.parentId ? this.meta.parentId : 'radioComponents'}
              checked={this.params.value === true}>
              {this.params.label}
            </input>
          )}
        </label>
      )
    }
    // style='background:#c1f1b8;border:0px;padding-left:5px;'
    // style={'cursor:pointer;border:1px solid ' + this.params.borderColor + ';background:' + this.params.color}
    return (
      <div
        class="match-parent"
        draggable="false"
        id={this.meta.id + '_div '}
        style={
          'cursor:pointer;padding:4px;border:2px solid ' +
          this.params.borderColor +
          ';background:' +
          this.params.color +
          ';box-sizing:border-box;'
        }>
        {['input'].includes(this.params.type) && this.params.fieldname === undefined ? (
          <span
            class="match-parent"
            style={
              'cursor:pointer;color:black;display: flex;align-items: center;justify-content: center;font-size:12px;min-height:24px;' +
              (this.params.disabled === true ? 'pointer-events:none;' : '')
            }>
            {' '}
            文字{' '}
          </span>
        ) : (
          <input
            class="match-parent"
            style={
              'border:none;background:transparent;padding:2px 4px;width:100%;height:100%;box-sizing:border-box;font-size:12px;outline:none;' +
              (this.params.disabled === true ? 'pointer-events:none;' : '')
            }
            type="text"
            id={this.meta.id}
            placeholder={this.params.placeholder || this.params.fieldname}
            v-model={this.params.value}
            disabled={this.params.usertype !== 'Doctor'}></input>
        )}
      </div>
    )
  }
}

const DatePicker = {
  props: {
    params: {
      default: () => ({})
    },
    meta: {
      default: () => ({ children: [] })
    }
  },
  render() {
    return (
      <div
        draggable="false"
        class="match-parent"
        style={
          'cursor:pointer;padding:4px;border:2px solid ' +
          this.params.borderColor +
          ';background:' +
          this.params.color +
          ';box-sizing:border-box;'
        }>
        {/* <span class='match-parent' draggable='false' onclick={document.getElementById('aaa').focus()} style={'cursor:pointer;border:1px solid ' + this.params.borderColor + ';background:' + this.params.color + ';color:black;display: flex;align-items: center;justify-content: center;font-size:12px;'}> {this.params.value ? this.params.value : this.params.name} </span> */}
        <el-date-picker
          disabled={this.params.disabled ? true : this.params.usertype !== 'Doctor'}
          class="match-parent"
          id={this.meta.id}
          v-model={this.params.value}
          type={this.params.inputType}
          placeholder={this.params.placeholder}
          style={
            'cursor:pointer;border:2px solid ' +
            this.params.borderColor +
            ';background:' +
            this.params.color +
            ';color:black;display: flex;align-items: center;justify-content: center;font-size:12px;padding:4px;box-sizing:border-box;min-height:32px;' +
            (this.params.disabled === true ? 'pointer-events:none;' : '')
          }
          format={this.params.inputType === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'}
          value-format={this.params.inputType === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'}
        />
        {/* <input type="datetime-local" class='match-parent' /> */}
      </div>
    )
  }
}

const SexSelection = {
  props: {
    params: {
      default: () => ({})
    },
    meta: {
      default: () => ({ children: [] })
    }
  },
  render() {
    return (
      <div
        draggable="false"
        class="match-parent"
        style={
          'cursor:pointer;display:flex;padding:3px;border:1px solid ' +
          this.params.borderColor +
          ';background:' +
          this.params.color
        }>
        <input
          disabled={true}
          type="radio"
          class="match-parent"
          id={this.meta.id + '_male'}
          name={this.meta.id}
          value="M"
          v-model={this.params.value}
        />
        <label class="match-parent input-has-label" style="color:black">
          {'Male'}
        </label>
        <input
          disabled={true}
          type="radio"
          class="match-parent"
          value="F"
          id={this.meta.id + '_female'}
          name={this.meta.id}
          v-model={this.params.value}
        />
        <label class="match-parent input-has-label" style="color:black">
          {'Female'}
        </label>
      </div>
    )
  }
}

const RelationshipTopatient = {
  props: {
    params: {
      default: () => ({})
    },
    meta: {
      default: () => ({ children: [] })
    }
  },
  render() {
    if (this.params.disabled === true) {
      return (
        <div
          draggable="false"
          class="match-parent"
          style={
            'cursor:pointer;display:flex;padding-top:5px;padding-right:5px;border:1px solid ' +
            this.params.borderColor +
            ';background:' +
            this.params.color +
            '7f'
          }>
          <label style="width:100%;color:black;text-align:right;font-size:12px">{this.params.name}</label>
        </div>
      )
    } else {
      return (
        <div
          draggable="false"
          class="match-parent"
          id={this.meta.id + '_div'}
          style={
            'cursor:pointer;padding-top:5px;padding-right:5px;border:1px solid ' +
            this.params.borderColor +
            ';background:' +
            this.params.color +
            '7f'
          }>
          <div style="width:100%;height:25px;color:black;text-align:right;">
            <label style="font-size:12px">{this.params.name}</label>
          </div>
          <div style="width:100%;height:calc(100% - 25px);display:flex;">
            <div style="width:65%;height:100%;display:flex;">
              <input
                disabled
                type="radio"
                class="match-parent"
                id={this.meta.id + '_me'}
                name={this.meta.id + '_radio'}
                value="本人"
                v-model={this.params.value}
              />
              <label class="match-parent input-has-label" style="color:black;font-size:12px">
                {'本人'}
              </label>
              <input
                disabled
                type="radio"
                class="match-parent"
                value="病患之"
                id={this.meta.id + '_relationship'}
                name={this.meta.id + '_radio'}
                v-model={this.params.value}
              />
              <label class="match-parent input-has-label" style="color:black;font-size:12px">
                {'病患之'}
              </label>
            </div>
            <div style="width:35%;height:100%;display:flex;">
              {this.params.value === '病患之' ? (
                <input
                  class="match-parent"
                  style="text-align:center"
                  type="text"
                  id={this.meta.id}
                  v-model={this.params.relationship}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      )
    }
  }
}

const Select = {
  props: {
    params: {
      default: () => ({
        value: '',
        options: [{ label: 'text', value: 'text' }]
      })
    }
  },
  render() {
    return (
      <select class="match-parent" type={this.params.type} value={this.params.url}>
        {this.params.options.map((item) => (
          <option value={item.value} key={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    )
  }
}

const Rect = {
  render() {
    return <div class="match-parent" class="rect" />
  }
}

export default {
  signature: Signature,
  img: Img,
  input: Input,
  select: Select,
  rect: Rect,
  label: Label,
  container: Container,
  date: DatePicker,
  sex: SexSelection,
  relationshiptopatient: RelationshipTopatient
}
